import { render, staticRenderFns } from "./Monitors.vue?vue&type=template&id=2bb41c91"
import script from "./Monitors.vue?vue&type=script&lang=js"
export * from "./Monitors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports